import { shopifyAppBridge } from '../App';

// Deduplication: track when each message was last shown.
// Prevents the same toast from re-firing within 5 s (e.g. App Bridge replaying
// toasts on SPA navigation due to the old App Bridge lifecycle messages).
const _lastShownAt = new Map();
const DEDUP_MS = 5000;

/**
 * Global toast helper utility
 * Automatically hides toast after 3 seconds
 * @param {string} message - Toast message to display
 * @param {Object} options - Toast options
 * @param {boolean} options.isError - Whether this is an error toast (default: false)
 * @param {number} options.duration - Duration in milliseconds (default: 3000)
 */
export function showToast(message, options = {}) {
  const { isError = false, duration = 3000, action = null, onAction = null } = options;

  if (!shopifyAppBridge || !shopifyAppBridge.toast) {
    return;
  }

  const now = Date.now();
  const lastShown = _lastShownAt.get(message);
  if (lastShown && (now - lastShown) < DEDUP_MS) return;
  _lastShownAt.set(message, now);

  const toastOptions = {
    duration,
    isError
  };

  if (action && onAction) {
    toastOptions.action = action;
    toastOptions.onAction = onAction;
  }

  shopifyAppBridge.toast.show(message, toastOptions);
}

/**
 * Show success toast (auto-hides after 3 seconds)
 */
export function showSuccessToast(message, action = null, onAction = null) {
  showToast(message, { isError: false, duration: 3000, action, onAction });
}

/**
 * Show error toast (auto-hides after 3 seconds)
 */
export function showErrorToast(message, action = null, onAction = null) {
  showToast(message, { isError: true, duration: 3000, action, onAction });
}


